import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { ConversationFilterEnum } from 'common/enums';
import React from 'react';
import { useChatStore } from 'store/useChatStore';
import {
  ConversationsFilterTypeMap,
  mapConversationPriorityColor
} from 'utils/conversations';
import { useShallow } from 'zustand/shallow';
import { useSelectedDeviceStore } from 'store/useSelectedDeviceStore';
import { useMixpanel } from 'utils/hooks/useMixPanel';

export default function ConversationsFilter() {
  const {
    setConversationFilter,
    conversationFilter,
    conversationCount
  } = useChatStore(
    useShallow((state) => ({
      conversationCount: state.conversationsCount,
      conversationFilter: state.conversationFilter,
      setConversationFilter: state.setConversationFilter
    }))
  );

  const { chatInteraction } = useMixpanel();
  const { selectedDevice } = useSelectedDeviceStore();
  const filters = Object.keys(ConversationsFilterTypeMap) as ConversationFilterEnum[]

  return (
    <Box mt={2} sx={{ display: 'flex' }} pr={{ md: 1 }}>
      <Tabs
        value={filters.indexOf(conversationFilter)}
        TabIndicatorProps={{ style: { display: 'none' } }}
        variant='scrollable'
        scrollButtons
        allowScrollButtonsMobile
        sx={{
          alignItems: 'center',
          '& .MuiTabs-flexContainer': {
            gap: '8px'
          },
          '& .MuiTabScrollButton-root': {
            width: 'none'
          }
        }}
      >
        {Object.keys(ConversationsFilterTypeMap).map(
          (filter: ConversationFilterEnum, index) => {
            const color =
              conversationFilter === filter &&
              mapConversationPriorityColor(filter);

            return (
              <Tab
                key={index}
                label={`${ConversationsFilterTypeMap[filter]()} (${conversationCount[filter]})`}
                onClick={() => {
                  setConversationFilter(filter);
                  if (selectedDevice) {
                    chatInteraction(selectedDevice, 'filter-selected', {
                      filter
                    });
                  }
                }}
                sx={{
                  minHeight: '30px',
                  backgroundColor: color.light,
                  borderRadius: '15px',
                  fontSize: '0.8rem',
                  textTransform: 'none',
                  minWidth: '20px',
                  padding: '10px',
                  color: color.main
                }}
              />
            );
          }
        )}
      </Tabs>
    </Box>
  );
}
